<!-- 智答 -->
<template>
    <div class="content" :class="sidebarShow?'active':'active2'" :style="contentMargin?'margin-left:10vw;':''">
        <div class="titleBox" v-show="!startAnswer">
            <div class="nameBox">
                <img class="titleImg" @click="changeInput()" src="../../assets/images/webAiTitleIcon.png" alt="">
                <div class="name">Hi 我是小智！</div>
            </div>
            <div class="tagline">
                宠物医生的专属智能助手，随时准备为你提供学习帮助和诊疗支持~
            </div>
        </div>
        <div class="textTitle" v-if="startAnswer && textDataBox.length > 0">
            {{ textDataBox[0].question.slice(0,20) }}
        </div>
        <div class="textBox" v-show="startAnswer" id="chatContainer">
            <div class="answerItem" v-for="(item, index) in textDataBox" :key="index">
                <div class="rightText">
                    <div class="imgItem" v-for="(file, index1) in item.filesArr" :key="index1">
                        <el-image
                            style="width: 50px;height: 50px;"
                            :src="require('../../assets/images/webAiIcon11.png')"
                            v-if="file.fileSuffix.startsWith('image') || file.fileSuffix.startsWith('png') || file.fileSuffix.startsWith('jpg')"
                            fit="contain"></el-image>
                        <el-image
                            style="width: 50px;height: 50px;"
                            :src="require('../../assets/images/webAiIcon.png')"
                            v-else
                            fit="contain"></el-image>
                        <div class="imgInfo">
                            <div class="imgName">
                                {{ file.fileName }}
                            </div>
                            <div class="imgsize">
                                <span v-if="file.fileSuffix.startsWith('image') || file.fileSuffix.startsWith('png') || file.fileSuffix.startsWith('jpg')">
                                    {{ file.fileSuffix }}
                                </span> 
                                <span>
                                    文件
                                </span>
                                {{ Math.floor((file.fileSize/1024)*100)/100 + "KB" }}
                            </div>
                        </div>
                    </div>
                    {{ item.question }}
                </div>
                <div class="clear" style="clear:right"></div>
                <!-- 有答案或者正在思考 -->
                <div class="leftBox" v-if="item.replyText || item.textOver == 1">
                    <div class="leftImg">
                        <img class="logo" src="../../assets/images/webAiTitleIcon.png" alt="">
                        小智
                    </div>
                    <div class="leftText" style="padding-left:20px; display: flex;" v-if="item.textOver == 1">
                        {{ task }}
                        <div class="loading-container">
                            <div class="dot dot-1"></div>
                            <div class="dot dot-2"></div>
                            <div class="dot dot-3"></div>
                        </div>
                    </div>
                    <div class="leftText" v-if="item.replyText">
                        <div class="aiText" v-html="item.replyText"></div>
                        <div class="outputsBox" v-if="item.outputs.length > 0">
                            <div class="titles">以上基于{{item.outputs.length }}份相关资料作为参考</div>
                            <div class="outputsItem" v-show="item.extendOff || index1 < 3" v-for="(item1, index1) in item.outputs" :key="index1" @click="jumpOutputsItem(item1)">
                                <span :class="item1.dataset_name=='课程'?'dataName color1':'dataName color2'">{{ item1.dataset_name }}</span>
                                {{ item1.title }}
                            </div>
                            <div class="btn" v-show="item.outputs.length > 3" @click="item.extendOff = !item.extendOff">
                                <img class="extendBtn" :style="item.extendOff?'':'transform: rotate(180deg)'"  src="../../assets/images/extendBtn.png" alt="">
                                <span v-show="!item.extendOff">展开</span>
                                <span v-show="item.extendOff">收起</span>
                            </div>
                        </div>
                        <div class="btnList" v-show="item.textOver == 2">
                            <div class="btnItem" @click="copyData(item)"><i class="el-icon-copy-document"></i> 复制</div>
                            <div class="btnItem" @click="answersLikeOrTap(item, 1)">
                                <img class="icon" :src="item.action == 1?require('../../assets/images/likeIcon1.png'):require('../../assets/images/likeIcon.png')" alt="">赞
                            </div>
                            <div class="btnItem" @click="answersLikeOrTap(item, 2)">
                                <img class="icon bottom" :src="item.action == 2?require('../../assets/images/likeIcon1.png'):require('../../assets/images/likeIcon.png')" alt="">踩
                            </div>
                        </div>
                    </div>
                </div>
                <div class="clear" style="clear:left"></div>
                <div class="videoList" v-show="index == textDataBox.length-1 && item.relatedreCommended.length > 0">
                    <div class="listTitle">推荐视频</div>
                    <div class="videoDataList">
                        <div class="videoItem" @click="jumpOutputsItem(item1)" v-for="(item1, index1) in item.relatedreCommended" :key="index1">
                            <img class="videoImg" :src="item1.list_image?imgSrc+item1.list_image:require('../../assets/images/default.jpg')" alt="">
                            <div class="videoName">{{ item1.title }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="filesBox">
            <div v-show="previewFiles.length > 0" v-for="(file, index) in previewFiles" :key="index" class="fileItem" >
                <el-image
                    style="width: 50px;height: 50px;"
                    :src="require('../../assets/images/webAiIcon11.png')"
                    v-if="file.fileSuffix.startsWith('image') || file.fileSuffix.startsWith('png') || file.fileSuffix.startsWith('jpg')"
                    fit="contain"></el-image>
                <el-image
                    style="width: 50px;height: 50px;"
                    :src="require('../../assets/images/webAiIcon.png')"
                    v-else
                    fit="contain"></el-image>
                <div class="imgInfo">
                    <div class="imgName">
                        {{ file.fileName }}
                    </div>
                    <div class="imgsize">
                        <span v-if="file.fileSuffix.startsWith('image') || file.fileSuffix.startsWith('png') || file.fileSuffix.startsWith('jpg')">
                            {{ file.fileSuffix }}
                        </span> 
                        <span>
                            文件
                        </span>
                        {{ Math.floor((file.fileSize/1024)*100)/100 + "KB" }}
                    </div>
                </div>
                <img class="deleteBtn" @click="removeFile(index)" src="../../assets/images/imgCloseBtn.png" alt="">
            </div>
        </div>
        <div class="inputBox">
            <textarea class="inputBtn" v-model="textMsg" placeholder="有什么问题尽管问我，Shift+Enter换行"></textarea>
            <div class="btnBox">
                <!-- <div :class="llmType == 1?'btnItem actives': 'btnItem'" @click="changeConnectedInternet(2)">
                    <img :src="llmType==1?require('../../assets/images/btnIcon3.png'):require('../../assets/images/btnIcon1.png')" alt="">
                    深度思考
                </div>
                <div :class="connectedInternet==1?'btnItem actives':'btnItem'" @click="changeConnectedInternet(1)">
                    <img :src="connectedInternet==1?require('../../assets/images/btnIcon4.png'):require('../../assets/images/btnIcon2.png')" alt="">
                    联网搜索
                </div> -->
                <div class="btnItem"  @click="jumpwebAICase()">
                    <img :src="connectedInternet==1?require('../../assets/images/btnIcon5.png'):require('../../assets/images/btnIcon5.png')" alt="">
                    查看病例
                </div>
            </div>
            <el-popover
                placement="top-start"
                trigger="hover"
                width="30px"
                title="上传附件（仅识别文字）"
                content="最多1个，每个5MB，支持各类文档和图片">
                <img class="uploadBtn" slot="reference" :src="require('../../assets/images/uploadfileBtn.png')" alt="" @click="changeInput()">
            </el-popover>
            <img class="sendBtn" :src="Answering?require('../../assets/images/sendBtn2.png'):require('../../assets/images/sendBtn.png')" alt="" @click="submitQuestion()">
        </div>
        <div class="toast" :class="sidebarShow?'active3':'active4'" :style="contentMargin?'margin-left:5.5VW;':''">
            结果由AI大模型生成，不属于诊断行为，仅供参考;使用者应自行鉴别并对使用结果负责，禁止从事违法活动。
        </div>
        <input class="uploadfileInput" id="otherElement" style="display: none;" type="file" @change="upFileData" />

        <div class="agentList" v-show="!startAnswer">
            <!-- <div class="agentItem" @click="jumpwebAIagent()">
                <img class="agentItemImg" src="../../assets/images/webAIagentIcon.png" alt="">
                执考助教
            </div> -->
            <!-- <div class="agentItem" @click="jumpwebAIagent()">
                <img class="agentItemImg" src="../../assets/images/webAIagentIcon.png" alt="">
                病例决策
            </div> -->
        </div>


        <!-- 侧边栏 -->
        <div class="sidebarBox" v-show="!sidebarShow">
            <div class="iconBox">
                <img class="icon logo" src="../../assets/images/logoIcon.png" alt="" @click="jumpIndex()">
                <img class="icon" src="../../assets/images/webAiIcon1.png" alt="" @click="zhankai()">
                <img class="icon" src="../../assets/images/webAiIcon2.png" alt="" @click="createdTextBox()">
            </div>
            <div class="iconBox">
                <el-popover
                    placement="top-start"
                    trigger="hover">
                    <img style="width: 200px;" src="../../assets/images/APPerweima.png" alt="">
                    <div class="text" style=" display: flex;justify-content: center;width: 200px;text-align: center;">
                        获取更多课程资讯<br>
                        移动端使用智答<br>
                        请扫码下载宠医客APP
                    </div>
                    <img slot="reference" class="icon phone" src="../../assets/images/webAiIcon3.png" alt="">
                </el-popover>
                <img class="icon userImg" :src="loginInfo.HeadPortrait?loginInfo.HeadPortrait:require('../../assets/images/webAiUserIcon.png')" alt="">
            </div>
        </div>
        <div class="sidebarBox2" v-show="sidebarShow">
            <div class="topBox">
                <div class="sidebarTitleBox">
                    <div class="sidebarTitle">宠医客智答</div>
                    <img class="offBtn" src="../../assets/images/webAiIcon4.png" alt="" @click="zhankai()">
                </div>
                <div class="addBtnBox" @click="createdTextBox()">
                    <img class="addImg" src="../../assets/images/webAiIcon5.png" alt="">
                    <div class="addTitle">开启新对话</div>
                </div>
            </div>
            <div class="historyList">
                <div class="historyListItem" v-for="(item, index) in historyDataList" :key="index">
                    <div class="historyListItemTitle">
                        {{ item.name }}
                    </div>
                    <div :class="item.name=='今天'?'historyItem bottom':'historyItem'" 
                        :style="item1.conversation_id == conversationId?'background-color: #dcebfe;':''"
                        v-show="item.cardList.length > 0"
                        v-for="(item1, index1) in item.cardList" :key="index1"
                        @click="getConversationHistory(item1)">
                        <div class="text">
                            {{ item1.question }}
                        </div>
                        <input :ref="'myInput'+index+index1" type="text" v-show="item1.inpOff" class="editInp" v-model="item1.question" @blur="updateConversationName(item1)">
                        <img class="openBtn" @click.stop="item1.editOff = true" src="../../assets/images/webAiIcon6.png" alt="" >
                        <div class="bgi" v-show="item1.editOff" @click.stop="item1.editOff = false"></div>
                        <div class="bgi" v-show="item1.inpOff" @click.stop="item1.inpOff = false"></div>
                        <div class="deleteBox" v-show="item1.editOff">
                            <div class="btnItem" @click.stop="onEdit(item1, index+''+index1)">
                                <img class="btnIcon" src="../../assets/images/editIcon.png" alt="">
                                重命名
                            </div>
                            <div class="btnItem" @click.stop="deleteConversationHistory(item1)">
                                <img class="btnIcon" src="../../assets/images/deleteIcon.png" alt="">
                                删除
                            </div>
                        </div>
                    </div>
                    <div class="" v-show="item.cardList.length == 0">
                        暂无搜索
                    </div>
                </div>
            </div>
            <div class="btmBox" style="height: 100px;padding-top: 20px;">
                <div class="appBtn" @click="downloadAPP()">
                    <img class="logoIcon" src="../../assets/images/logoIcon.png" alt="">
                    下载宠医客APP
                </div>
            </div>
            <div class="btmBox">
                <img class="userImg" :src="loginInfo.HeadPortrait?loginInfo.HeadPortrait:require('../../assets/images/webAiUserIcon.png')" alt="">
                {{ loginInfo.name }}
            </div>
        </div>


    </div>
</template>

<script>
    import Cookies from 'js-cookie'
    import hex_md5 from "../../assets/js/md5"
    import { marked } from 'marked';
    export default {
        data() {
            return {
			    imgSrc: "https://case.chongyike.com",
                textMsg: "",
                // 流式数据id
                conversationId: "",
                conversationType: "2",
                // 侧边栏是否展开
                sidebarShow: false,
                // 历史记录
                historyDataList: [],
                // 是否开始问答
                startAnswer: false,
                // 对话数据列表
                textDataBox: [],
                // 是否在回答中
                Answering: false,
                loginInfo: {},
                // 字符串长度
                markedTextlength: 0,
                // 聊天窗是否有外距离
                contentMargin: false,
                // 保存当前问答的ID
                atPresentConversationID: "",
                // 是否联网搜索
                connectedInternet: 0,
                llmType: 0,
                // 预览上传文件
                previewFiles: [],
                // 上传地址
                uploadData: [],
                // 当前思考状态
                task: "思考中"
            };
        },
        created() {
            const that = this
            if(sessionStorage.getItem("AiCaseQuestion")){
                if(JSON.parse(sessionStorage.getItem("AiCaseQuestion")).question){
                    // 带问题提问
                    that.textMsg = JSON.parse(sessionStorage.getItem("AiCaseQuestion")).question
                    that.submitQuestion()
                }else {
                    sessionStorage.removeItem("AiCaseQuestion")
                }
            }
            if(sessionStorage.getItem("atPresentConversationID")){
                // 参考资料回退
                var text = JSON.parse(sessionStorage.getItem("atPresentConversationID"))
                that.sidebarShow = text.sidebarShow
                var data = {
                    conversation_id: text.atPresentConversationID
                }
                that.getConversationHistory(data)
            }
            that.getConversationList()
            window.addEventListener("keydown", this.keydownClick)
            // 已经有登录信息则直接取
            if(that.Cookies.get("loginInfo")){
                that.loginInfo = JSON.parse(that.Cookies.get("loginInfo"))
            }
            
        },
        mounted(){
            // this.getmathJax()
        },
        watch: {
            // 回答时滚动条保持在底部
            markedTextlength() {
                this.$nextTick(() => {
                    var container = this.$el.querySelector("#chatContainer");
                    container.scrollTop = container.scrollHeight;
                })
            // document.getElementById('chatContainer').scrollTop = document.getElementById('chatContainer').scrollHeight+150;
            },
            // 监听侧边栏
            sidebarShow(newVal ){
                setTimeout(() => {
                    this.contentMargin = newVal
                }, 150);
            },
            // 正在回答中的问题在切换之后自动停止
            startAnswer(newVal){
                if(newVal == false && this.Answering){
                    this.stopAnswerts()
                }
            },
        },
        methods: {
            changeInput(){
                const otherElement = document.getElementById('otherElement');
                if (otherElement) {
                    otherElement.click();
                }
            },
            // handleKeydown(event) {
            //     //如果键盘敲击f12就阻止f12打开，然后弹框提醒
            //     if (event.key === "F12") {
            //         event.preventDefault(); // 阻止F12的默认行为
            //         this.$message("检测非法调试，F12被管理员禁用");
            //     }
            // },
            getmathJax () {
                this.$nextTick(function () {
                    if (this.mathJax.isMathjaxConfig) {//判断是否初始配置，若无则配置。
                        this.mathJax.initMathjaxConfig();
                    }
                    console.log(this.mathJax.isMathjaxConfig)
                    this.mathJax.MathQueue("chatContainer");//传入组件id，让组件被MathJax渲染
                });
            },
            // 跳转首页
            jumpIndex(){
                this.startAnswer = false
                this.$router.push({
                    path: '/home',
                })
            },
            // 跳转视频列表
            jumpVideolistInner(item){
                return false
                this.$router.push({
                    path: '/videolistInner/' + item.id,
                })
            },
            // 参考资料跳转
            jumpOutputsItem(item){
                const that = this
                if(item.data_type == 15){
                    this.stopAnswerts()
                    var data = {
                        dataType: 0,
                        No: item.data_no,
                        name: item.title,
                        classType: 1,
                    }
                    that.$router.push({
                        path: '/videoDetail',
                        query: {
                            text: that.encrypt(JSON.stringify(data))
                        }
                    })
                }else if (item.data_type == 3){
                    this.stopAnswerts()
                    that.$router.push({
                        path: '/postDetail/' + item.data_no,
                    })
                }
                var data = {
                    atPresentConversationID: that.atPresentConversationID,
                    sidebarShow: that.sidebarShow
                }
                sessionStorage.setItem("atPresentConversationID", JSON.stringify(data))
            },
            // 跳转智能体
            jumpwebAIagent(){
                const that = this
                this.$router.push({
                    path: '/webAIagent',
                })
            },
            jumpwebAICase(){
                const that = this
                var data = {
                    conversationId: this.conversationId
                }
                if(this.atPresentConversationID){
                    var text = {
                        atPresentConversationID: that.atPresentConversationID,
                        sidebarShow: that.sidebarShow
                    }
                    sessionStorage.setItem("atPresentConversationID", JSON.stringify(text))
                }
                this.$router.push({
                    path: '/AICaseHistory',
                    query: {
                        text: that.encrypt(JSON.stringify(data))
                    }
                })
            },
            // 打开下载APP页面
            downloadAPP(){
                window.open("https://sj.qq.com/appdetail/com.janlent.ytb")
            },
            // 开启新对话
            createdTextBox(){
                const that = this
                that.startAnswer = false
                that.textDataBox = []
                that.conversationId = ""
                that.atPresentConversationID = ""
            },
            // 点击重命名
            onEdit(item, index){
                item.inpOff = true
                item.editOff = false
                var a = 'myInput'+index
                this.$nextTick(()=>{
                    if(this.$refs[a]){
                        this.$refs[a][0].focus();
                    }
                })
            },
            // 删除历史记录
            deleteConversationHistory(item){
                const that = this
                item.inpOff = false
                var data = {
                    type: 'deleteConversationHistory',
                    conversationId: item.conversation_id,
                }
                this.get("/ai/decisionMaking", data, 1).then((res) => {
                    if (res.data.code == "success") {
                        var result = res.data.result
                        that.getConversationList()
                        that.$message({
                            showClose: true,
                            message: res.data.message,
                        });
                    }
                })
            },
            // 重命名方法
            updateConversationName(item){
                const that = this
                item.inpOff = false
                var data = {
                    type: 'updateConversationName',
                    conversationId: item.conversation_id,
                    newName: item.question
                }
                this.get("/ai/decisionMaking", data, 1).then((res) => {
                    if (res.data.code == "success") {
                        var result = res.data.result
                        that.$message({
                            showClose: true,
                            message: res.data.message,
                        });
                    }
                })
            },
            // 展开侧边栏
            zhankai(){
                const that = this
                that.sidebarShow = !that.sidebarShow
            },
            // 键盘事件
            keydownClick(e){
                const that = this 
                if(that.$route.path == '/webAICase'){
                    var keyCode = e.keyCode
                    if (e.key === 'Enter' && e.shiftKey) {
                        
                    }else if(keyCode == "13" && that.textMsg.trim().length > 0){
                        that.submitQuestion()
                    }
                }
            },
            // 打开历史提问
            getConversationHistory(item){
                const that = this
                var data = {
                    type: 'getConversationHistory',
                    conversationId: item.conversation_id
                }
                this.get("/ai/decisionMaking", data).then((res) => {
                    if (res.data.code == "success") {
                        if(sessionStorage.getItem("atPresentConversationID")){
                            sessionStorage.removeItem("atPresentConversationID")
                        }
                        // document.title = item.question.slice(0,10) + "- 智答"
                        var result = res.data.result
                        that.textMsg = ""
                        that.atPresentConversationID = item.conversation_id// 保存当前问答ID
                        result.reverse()
                        that.markedTextlength++ // 保持滚动条在最低端
                        that.startAnswer = true
                        that.conversationId = item.conversation_id
                        for (let i = 0; i < result.length; i++) {
                            if( result[i].files.length > 0){
                                result[i].filesArr = JSON.parse(result[i].files)
                                for (let k = 0; k < result[i].filesArr.length; k++) {
                                    result[i].filesArr[k].fileUrl = that.imgSrc + result[i].filesArr[k].fileUrl
                                }
                            }
                            if(result[i].answer){
                                var answer = JSON.parse(result[i].answer)
                                console.log(answer)
                                result[i].markedText = answer.content
                                result[i].replyText = marked(answer.content).replace(/<del>|<\/del>/g, "");
                                result[i].replyText = that.escapeUnescapedSquareBrackets(result[i].replyText)
                                result[i].outputs = answer.outputs
                                result[i].textOver = 2
                                result[i].relatedreCommended = answer.relatedreCommended
                            }else {
                                result[i].replyText = ""
                                result[i].outputs = ""
                                result[i].relatedreCommended = []
                                result[i].textOver = 0
                            }
                            result[i].extendOff = false
                        }
                        console.log(result)
                        setTimeout(() => {
                            window.MathJax.typesetPromise().then(() => {
                                console.log('MathJax rendering completed');
                            }).catch((error) => {
                                console.error('MathJax rendering error:', error);
                            });
                        }, 500);
                        that.textDataBox = result
                    }
                })
            },
            // 浏览记录
            aiPageBrowsingRecord(){
                const that = this
                var data = {
                    type: 'aiPageBrowsingRecord',
                    accessType: 7, // 7是官网
                    pageName: "vetChat3_1"
                }
                this.get("/ai/decisionMaking", data).then((res) => {
                    if (res.data.code == "success") {
                        var result = res.data.result
                        
                    }
                })
            },
            // 切换问题模式 深度思考 联网搜索
            changeConnectedInternet(item){
                const that = this
                // that.$message({
                //     message: "敬请期待",
                // });
                // return false

                if(that.previewFiles.length > 0){
                    return false
                }
                if(item == 1){
                    if(that.connectedInternet == 1){
                        that.connectedInternet = 0
                    }else {
                        that.connectedInternet = 1
                        that.llmType = 0
                    }
                }else if(item == 2){
                    if(that.llmType == 1){
                        that.llmType = 0
                    }else {
                        that.llmType = 1
                        that.connectedInternet = 0
                    }
                }
            },
            // 上传文件
            upFileData(event){
                const that = this
                if(this.previewFiles.length > 0){
                    return false
                }
                const selectedFiles = Array.from(event.target.files); // 将FileList转换为数组
                selectedFiles.forEach(file => {
                    // 创建预览URL，仅适用于图片等可以直接通过URL访问的文件类型
                    const previewURL = URL.createObjectURL(file);
                    if(file.size > (1024*1024*10)){
                        that.$message({
                            showClose: true,
                            message: "请选择小于10M的文件",
					        type: 'error'
                        });
                    }else {
                        console.log(file)
                        this.previewFiles.push({ fileName: file.name, fileSuffix: file.type, fileUrl: previewURL , fileSize: file.size});
                        that.uploadData.push(file);
                    }
                });
            },
            showtoast(){
                this.$message({
                    showClose: true,
                    message: "只能选择一个文件",
                    type: 'error'
                })
            },
            removeFile(index) {
                // 移除文件和预览URL，释放内存
                this.previewFiles.splice(index, 1);
                this.uploadData.splice(index, 1);
            },
            // 发送问题
            submitQuestion(){
                const that = this
                // 是否正在回答
                if(that.Answering){
                    that.stopAnswerts()
                }else {
                    if(that.textMsg.trim() == ""){
                        that.$message({
                            message: "请输入问题",
                        });
                        return false
                    }
                    // 开始问答
                    that.startAnswer = true
                    that.Answering = true
                    var uploadFile = new FormData();

                    // 数组添加新提问
                    var data = {
                        question: that.textMsg,
                        replyText: "",
                        outputs: [],
                        extendOff: false,
                        relatedreCommended: [],
                        filesArr: that.previewFiles
                    }
                    that.textDataBox.push(data)
                    if(that.uploadData.length > 0){
                        for (var i = 0; i < that.uploadData.length; i++) {
                            uploadFile.append("imgs", that.uploadData[i]);
                        }
                    }
                    uploadFile.append("question", that.textMsg);
                    // 清除文件列表
                    that.previewFiles = []
                    that.uploadData = []
                    var data = {
                        type: 'submitQuestion',
                        conversationId: that.conversationId,
                        conversationType: that.conversationType,
                        accessType: 7, // 7是官网
                        connectedInternet: that.connectedInternet,
                        llmType: that.llmType
                    }
                    this.post("/ai/decisionMaking", data, uploadFile).then((res) => {
                        if (res.data.code == "success") {
                            var result = res.data.result
                            document.title = that.textMsg.slice(0,10) + "- 智答"
                            if(sessionStorage.getItem("AiCaseQuestion")){
                                sessionStorage.removeItem("AiCaseQuestion")
                            }
                            that.markedTextlength+=1
                            that.sessionId = result.session_id
                            // 建立流式回复
                            that.connectToServer(result.session_id)
                            that.textDataBox[that.textDataBox.length-1].textOver = 1
                            // 清空输入框
                            that.textMsg = ""
                        }else {
                            that.Answering = false
                            that.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    })
                }
            },
            // 建立流式回复
            connectToServer(sessionId){
                const that = this
				var url = 'https://appinterface.chongyike.com/ai/decisionMaking?type=getAnswers&sessionId='+ sessionId + that.getConfigText()
				    //  url = 'http://192.168.18.121:82/ai/decisionMaking?type=getAnswers&sessionId='+ sessionId + that.getConfigText()
				// 建立连接
				let sourceInfo = new EventSource(url);
                // 保存原文参数
                var markedText = ""
                that.textDataBox[that.textDataBox.length-1].replyText = ""
				sourceInfo.onmessage = function(e){
                    var data = JSON.parse(e.data)
                    that.task = data.task
                    markedText += data.content
                    that.markedTextlength = markedText.length
                    that.textDataBox[that.textDataBox.length-1].replyText = marked(markedText).replace(/<del>|<\/del>/g, "");
					// 回复结束
                    if (data.finishReason == 1) {
                        var datatext = that.textDataBox[that.textDataBox.length-1].replyText
                        that.textDataBox[that.textDataBox.length-1].replyText = that.escapeUnescapedSquareBrackets(datatext)
                        setTimeout(() => {
                            window.MathJax.typesetPromise().then(() => {
                                console.log('MathJax rendering completed');
                            }).catch((error) => {
                                console.error('MathJax rendering error:', error);
                            });
                        }, 500);
                        that.conversationId = data.conversationID
                        that.atPresentConversationID = data.conversationID // 保存当前问答ID
                        that.textDataBox[that.textDataBox.length-1].outputs = data.outputs
                        that.textDataBox[that.textDataBox.length-1].textOver = 2
                        that.textDataBox[that.textDataBox.length-1].session_id = data.sessionId
                        that.textDataBox[that.textDataBox.length-1].relatedreCommended = data.relatedreCommended
                        that.textDataBox[that.textDataBox.length-1].markedText = markedText
                        that.markedTextlength = 0
                        that.getConversationList()
                        that.task = "思考中"
                    }
				}
				sourceInfo.addEventListener('error', function(e) {
					console.log('内容已断开');
                    that.Answering = false
					sourceInfo.close();
				}, false);
            },
            // 停止流式回复
            stopAnswerts(){
                const that = this
                var data = {
                    type: 'stopAnswerts',
					sessionId: that.sessionId
                }
                this.get("/ai/decisionMaking", data, 1).then((res) => {
                    if (res.data.code == "success") {
                        var result = res.data.result
                        that.Answering = false
                        if(that.textDataBox[that.textDataBox.length-1].replyText == "思考中......"){
                            that.textDataBox[that.textDataBox.length-1].replyText = ""
                        }
                        that.textDataBox[that.textDataBox.length-1].textOver = 2
                    }
                })
            },
            // 复制
            copyData(data) {
                const that = this
                console.log(data)
                const el = document.createElement('textarea');
                // 将需要复制的文本内容赋值给 textarea 元素。
                // el.value = data.markedText;
                el.value = data.replyText.replace(/\<.*?\>/g, '');;
                //将 textarea 元素添加到页面中。
                document.body.appendChild(el);
                //选中 textarea 元素中的文本。
                el.select();
                // 执行复制命令，将选中的文本复制到剪贴板
                document.execCommand('copy');
                //从页面中移除 textarea 元素。
                document.body.removeChild(el);
                //弹出提示框，告知用户文本已复制成功。
                this.$message.success("复制成功")
            },
            // 点赞或踩
            answersLikeOrTap(item,type){
                const that = this
                var action = type
                if(item.action == type){
                    action = 0
                }
                var data = {
                    type: 'answersLikeOrTap',
                    action: action,
                    sessionId: item.session_id
                }
                this.get("/ai/decisionMaking", data).then((res) => {
                    if (res.data.code == "success") {
                        var result = res.data.result
                        item.action = action
                    }
                })
            },
            // 获取历史记录
			getConversationList() {
				const that = this;
                var data = {
                    type: 'getConversationList',
                }
                this.get("/ai/decisionMaking", data, 1).then((res) => {
                    if (res.data.code == "success") {
                        var result = res.data.result
                        that.aiPageBrowsingRecord()
                        that.historyDataList = that.classifyData(result)
                    }
                })
			},
            getConfigText(){
                const that = this
                // 获取当前时间
                var time = (new Date()).getTime();
                var data = {
                    // 接口来源 安卓/IOS/WEB
                    client: "WEB",
                    // 版本号
                    device: "",
                    // 时间戳
                    requestTime: time,
                    // 版本号
                    versionCode: 251,
                }
                if(Cookies.get('device')){
                    data.device = Cookies.get('device')
                }else {
                    var lsnms = num();
                    var strs = time + "" + lsnms;
                    var device = hex_md5(strs).toUpperCase();
                    Cookies.set('device', device, {  expires: 7 })
                    data.device = device
                }
                data.sign = that.serSign(data)
                var texts = ""
                for (let key in data) {
                    if (data.hasOwnProperty(key)) {
                        texts +=  "&" +  key + "=" + data[key]
                    }
                }
                return texts
            },
            serSign(data){
                var text = ""
                for (let key in data) {
                    text = text + key + '=' + data[key] + "&"
                }
                return hex_md5(text + 'key=huiyichongyike')
            },
            // 划分时间
			classifyData(data) {
				const that = this;
				const today = new Date();
				const todayStartOfDay = new Date(today.getFullYear(), today.getMonth(), today.getDate())
					.getTime(); // 今天0点的时间戳
				const sevenDaysAgo = new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000);
				const thirtyDaysAgo = new Date(today.getTime() - 30 * 24 * 60 * 60 * 1000);

				const result = [{
						name: '今天',
						cardList: []
					},
					{
						name: '近7天',
						cardList: []
					},
					{
						name: '近30天',
						cardList: []
					},
					{
						name: '更早',
						cardList: []
					}
				];

				data.forEach(item => {
					const updateTime = new Date(item.update_time);
					item.formatted_time = that.formatTime(updateTime, today);
                    item.editOff = false
                    item.inpOff = false
					if (updateTime >= todayStartOfDay) {
						result[0].cardList.push(item); // 今天
					} else if (updateTime >= sevenDaysAgo.getTime()) {
						result[1].cardList.push(item); // 近7天
					} else if (updateTime >= thirtyDaysAgo.getTime()) {
						result[2].cardList.push(item); // 近30天
					} else {
						result[3].cardList.push(item); // 更早
					}
				});

				return result;
			},
			formatTime(date, today) {
				const that = this;
				const diff = Math.floor((today - date) / (24 * 60 * 60 * 1000));
				if (diff === 0) {
					return `${date.getHours()}:${date.getMinutes().toString().padStart(2, '0')}`; // 今天
				} else if (diff < 7) {
					return that.getDayOfWeek(date); // 近7天
				} else if (diff < 30) {
					return `${date.getMonth() + 1}/${date.getDate()}`; // 近30天
				} else {
					return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`; // 更早
				}
			},
			getDayOfWeek(date) {
				const days = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
				return days[date.getDay()];
			},
            escapeUnescapedSquareBrackets(str) {
                // 首先转义所有已有的反斜杠，以避免影响后续的匹配
                let result = str.replace(/\\/g, '\\\\');

                // 定义一个函数来决定是否需要在 [ 或 ] 前添加 \\
                function shouldEscape(match, offset, string) {
                    // 计算 match 之前有多少个反斜杠
                    let backslashes = (string.slice(0, offset).match(/\\+/g) || ['']).pop() || '';
                    // 如果反斜杠的数量是偶数（包括0），则需要转义
                    return backslashes.length % 2 === 0;
                }
                // 使用正则表达式替换未被转义的 [ 和 ]
                result = result.replace(/([[\]])/g, (match, p1, offset, string) => shouldEscape(match, offset, string) ? '\\\\' +
                    p1 : p1);
                result = result.replace(/([(\)])/g, (match, p1, offset, string) => shouldEscape(match, offset, string) ? '\\\\' +
                    p1 : p1);

                // 恢复原有的单个反斜杠
                result = result.replace(/\\\\/g, '\\');
                return result;
            }
        }
    }
</script>

<style lang="scss" scoped>
input, textarea {
    font-family: PingFangSC-Regular, PingFang SC, AlibabaPuHuiTi-Regular, Helvetica, AlibabaPuHuiTi;
}

.content {
    width: auto !important;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 0;
    border: none;

    .titleBox {
        padding-top: 22vh;
        .nameBox {
            display: flex;
            align-items: center;
            justify-content: center;
            .titleImg {
                width: 80px;
            }
            .name {
                font-size: 30px;
                padding-left: 35px;
            }
        }
        .tagline {
            padding-top: 30px;
            font-size: 18px;
            color: #777777;
        }
    }

    .textTitle {
        position: relative;
        font-size: 15px;
        color: #333;
        margin: 8vh 0 4vh;
        font-weight: 600;
        &::before {
            content: "";
            position: absolute;
            left: 50%;
            bottom: -5px;
            width: 100px;
            height: 2px;
            background-color: #333;
            transform: translateX(-50%);
        }
    }

    .textBox {
        overflow-x: hidden;
        overflow-y: scroll;
        width: 100%;
        height: 60vh;
        padding: 20px 0 0;
        box-sizing: border-box;
        line-height: 25px;
        .answerItem {
            width: 50vw;
            margin: 0 auto;
        }
        .rightText {
            float: right;
            padding: 10px;
            border-radius: 10px;
            margin-bottom: 20px;
            margin-left: 30px;
            font-size: 13px;
            background-color: #eef8ff;
            .imgItem {
                display: flex;
                align-items: center;
                width: 210px;
                padding: 10px;
                border-radius: 5px;
                margin-bottom: 10px;
                border: 1px solid #cacaca;
                background-color: #f9f9f9;
                .imgInfo {
                    padding-left: 10px;
                    color: #333;
                    user-select: none;
                    .imgName {
                        width: 100px;
                        overflow: hidden;
                        text-overflow: ellipsis;
						display: -webkit-box;
						-webkit-line-clamp: 1;
						-webkit-box-orient: vertical;
                        font-size: 18px;
                    }
                    .imgsize {
                        color: #b0b0b0;
                        font-size: 14px;
                        span {
                            padding-right: 10px;
                        }
                    }
                }
            }
        }
        .leftBox {
            float: left;
            .leftImg {
                width: 50vw;
                display: flex;
                align-items: center;
                color: #333;
                font-size: 18px;
                position: relative;
                left: -20px;
                margin-bottom: 10px;
                .logo {
                    width: 30px;
                    height: 30px;
                    padding: 5px;
                    border-radius: 50%;
                    // border: 1px solid #636363;
                    margin-right: 10px;
                }
            }
            .leftText {
                box-sizing: border-box;
                border-radius: 10px;
                margin-right: 30px;
                font-size: 15px;
                .outputsBox {
                    padding: 10px 20px;
                    margin-top: 10px;
                    color: #4b96ef;
                    border-left: 2px solid #c5e9ff;
                    .outputsItem {
                        width: 30vw;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        height: 30px;
                        line-height: 30px;
                        font-size: 13px;
                        cursor: pointer;
                        .dataName {
                            font-size: 12px;
                            padding: 2px 4px;
                            margin-right: 5px;
                            border-radius: 5px;
                            background-color: #ffefce;
                        }
                        .color1 {
                            color: #ff7b00;
                        }
                        .color2 {
                            color: #30c400;
                        }
                    }
                    .btn {
                        width: 100%;
                        text-align: center;
                        user-select: none;
                        cursor: pointer;
                        .extendBtn {
                            width: 18px;
                            padding: 0 5px;
                        }
                    }
                }

                .btnList {
                    display: flex;
                    align-items: center;
                    padding: 10px 0;
                    .btnItem {
                        display: flex;
                        align-items: center;
                        font-size: 12px;
                        padding: 0px 10px;
                        color: #4488cc;
                        border-radius: 100px;
                        margin-right: 10px;
                        border: 1px solid #4488cc;
                        cursor: pointer;
                        .icon {
                            width: 15px;
                        }
                        .bottom {
                            transform: rotate(180deg);
                        }
                    }
                }
            }
        }

        .videoList {
            // padding-left: 20px;
            .listTitle {
                position: relative;
                padding-left: 10px;
                font-size: 18px;
                font-weight: 600;
                color: #000;
                padding-bottom: 5px;
                &::before {
                    content: "";
                    position: absolute;
                    left: 0;
                    top: 3px;
                    width: 3px;
                    height: 20px;
                    background: linear-gradient(#659cff,#659cff,#fff);
                }
            }
            .videoDataList {
                overflow-x: scroll;
                display: flex;
                align-items: center;
                user-select: none;
                .videoItem {
                    margin-right: 15px;
                    cursor: pointer;
                    &:nth-last-child(1){
                        margin-right: 0;
                    }
                    .videoImg {
                        width: 130px;
                        height: 90px;
                        border-radius: 5px;
                    }
                    .videoName {
                        overflow: hidden;
                        text-overflow: ellipsis;
						display: -webkit-box;
						-webkit-line-clamp: 2;
						-webkit-box-orient: vertical;
                        width: 130px;
                        height: 50px;
                        font-size: 16px;
                    }
                }
            }
        }
    }

    .filesBox {
        display: flex;
        align-items: center;
        width: 50vw;
        margin-top: 2vh;
        padding-top: 20px;
        overflow-x: auto;
        .fileItem {
            position: relative;
            display: flex;
            align-items: center;
            width: 210px;
            padding: 10px;
            border-radius: 5px;
            margin-right: 20px;
            border: 1px solid #cacaca;
            background-color: #f9f9f9;
            .imgInfo {
                padding-left: 10px;
                color: #333;
                user-select: none;
                .imgName {
                    width: 140px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    font-size: 18px;
                }
                .imgsize {
                    color: #b0b0b0;
                    font-size: 14px;
                    span {
                        padding-right: 10px;
                    }
                }
            }
            .deleteBtn {
                position: absolute;
                right: -10px;
                top: -10px;
                width: 20px;
                height: 20px;
                cursor: pointer;
            }
        }
    }

    .inputBox {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 50vw;
        height: 15vh;
        margin-top: 1.5vh;
        background-color: #f3f4f6;
        border-radius: 20px;
        .inputBtn {
            width: 48vw;
            height: 10vh;
            font-size: 24px;
            padding: 2vh 0;
            box-sizing: border-box;
            border: none;
            user-select: none;
            outline: none;
            resize: none;
            font-size: 18px;
            background-color: rgba(0,0,0,0);
        }
        
        .uploadfileInput {
            position: absolute;
            right: 80px;
            bottom: 20px;
            width: 30px;
            border-radius: 50%;
            z-index: 2;
            opacity: 0;
            cursor: pointer;
        }
        .uploadBtn {
            position: absolute;
            right: 80px;
            bottom: 20px;
            width: 30px;
            border-radius: 50%;
            cursor: pointer;
        }
        .sendBtn {
            position: absolute;
            right: 30px;
            bottom: 20px;
            width: 30px;
            border-radius: 50%;
            cursor: pointer;
        }
        .btnBox {
            position: absolute;
            left: 0px;
            bottom: 15px;
            width: 80%;
            padding-left: 20px;
            display: flex;
            box-sizing: border-box;
            background-color: #f3f4f6;
            .btnItem {
                display: flex;
                align-items: center;
                font-size: 16px;
                color: #48bdff;
                margin-right: 10px;
                border: 1px solid #48bdff;
                border-radius: 100px;
                padding: 3px 10px;
                cursor: pointer;
                user-select: none;
                img {
                    width: 16px;
                    margin-right: 5px;
                }
            }
            .actives {
                color: #6fa1f0;
                background-color: #eef5ff;
                border: 1px solid #6fa1f0;
            }
        }
    }

    .agentList {
        display: flex;
        align-items: center;
        width: 50vw;
        padding: 1vw 1vw;
        box-sizing: border-box;
        .agentItem {
            display: flex;
            align-items: center;
            border: 1px solid #cecece;
            border-radius: 100px;
            padding: 5px 15px;
            margin-right: 15px;
            cursor: pointer;
            .agentItemImg {
                width: 30px;
                height: 30px;
                margin-right: 5px;
                border-radius: 50%;
            }
        }
    }

    .toast {
        position: fixed;
        text-align: center;
        left: 50%;
        bottom: 10px;
        font-size: 12px;
        width: 100vw;
        color: #aaa;
        transform: translateX(-50%);
    }

    .sidebarBox, .sidebarBox2 {
        position: fixed;
        left: 0;
        top: 0;
        width: 60px;
        height: 100vh;
        user-select: none;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        background: linear-gradient(#ebf6ff,#f1f9ff, #f9fcff,#fff);

        .iconBox {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: center;
            padding: 20px 0;
            .icon {
                width: 30px;
                margin: 15px 0;
                cursor: pointer;
            }
            .logo {
                width: 40px;
            }
            .phone {
                width: 20px;
            }
            .userImg {
                width: 40px;
                border-radius: 50%;
            }
        }
    }

    .sidebarBox2 {
        width: 240px;
        padding: 20px 0;
        box-sizing: border-box;
        background-color: #f2f3ff;
        .topBox {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: center;
            .sidebarTitleBox {
                display: flex;
                justify-content: space-between;
                align-items: center;
                width: 100%;
                padding: 0 30px;
                box-sizing: border-box;
                .sidebarTitle {
                    font-size: 22px;
                    font-weight: 600;
                }
                .offBtn {
                    width: 26px;
                    cursor: pointer;
                }
            }
            .addBtnBox {
                display: flex;
                align-items: center;
                padding: 20px 20px 10px;
                box-sizing: border-box;
                width: 100%;
                cursor: pointer;
                .addImg {
                    width: 35px;
                    padding-right: 5px;
                }
                .addTitle {
                    font-size: 18px;
                    color:#5ea4f7;
                }
            }
        }

        .historyList {
            overflow-y: scroll;
            overflow-x: hidden;
            padding: 0px 20px 20px;
            min-height: 75vh;
            box-sizing: border-box;
            .historyListItem {
                padding: 10px 0;         
                .historyListItemTitle {
                    font-size: 18px;
                    // font-weight: 600;
                }
                .historyItem {
                    position: relative;
                    display: flex;
                    align-items: center;
                    border-radius: 5px;
                    // border: 1px solid #f2f3ff;
                    cursor: pointer;
                    &:hover {
                        border-radius: 5px;
                        // border: 1px solid #d5dfff;
                        background-color: #eff6ff;
                        .openBtn {
                            display: block;
                        }
                    }
                    .text {
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        height: 28px;
                        line-height: 28px;
                        padding: 0 5px;
                        padding-right: 30px;
                        font-size: 14px;
                        box-sizing: border-box;
                    }
                    .editInp {
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 30px;
                        padding: 0 5px;
                        z-index: 4;
                        box-sizing: border-box;
                        background-color: #fff;
                        border: none;
                        user-select: none;
                        outline: none;
                    }
                    .openBtn {
                        position: absolute;
                        display: none;
                        top: 3px;
                        right: 10px;
                        width: 20px;
                    }
                    .bgi {
                        position: fixed;
                        left: 0;
                        top: 0;
                        width: 100vw;
                        height: 100vh;
                        z-index: 2;
                        background-color: rgba(0,0,0,.0);
                    }
                    .deleteBox {
                        position: absolute;
                        right:0;
                        bottom: 0;
                        padding: 10px;
                        transform: translateY(-50%);
                        border-radius: 5px;
                        box-shadow: 0 0 10px #ccc;
                        background-color: #fff;
                        z-index: 3;
                        .btnItem {
                            display: flex;
                            align-items: center;
                            color: #ff3642;
                            &:nth-child(1){
                                color: #636363;
                                margin-bottom: 10px;
                            }
                            .btnIcon {
                                width: 20px;
                                margin-right: 5px;
                            }
                        }
                    }
                }
                .bottom {
                    .deleteBox {
                        transform: translateY(100%);
                    }
                }
            }
        }

        .btmBox {
            display: flex;
            align-items: center;
            // justify-content: center;
            // width: 300px;
            width: 100%;
            padding: 20px 15px 20px;
            font-size: 18px;
            box-sizing: border-box;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            .userImg {
                width: 35px;
                border-radius: 50%;
                margin-right: 5px;
            }
            .appBtn {
                display: flex;
                align-items: center;
                padding: 5px 8px;
                border-radius: 10px;
                font-size: 15px;
                color: #333;
                border: 1px solid #5ea4f7;
                user-select: none;
                cursor: pointer;
                .logoIcon {
                    width: 25px;
                    padding-right: 10px;
                }
            }
        }
    }
}

.loading-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 2px;
}

.dot {
    width: 4px;
    height: 4px;
    margin: 0 2px;
    background-color: #007bff;
    border-radius: 50%;
    animation: blink 1s linear infinite;
}

.dot-1 {
    animation-delay: 0s;
}

.dot-2 {
    animation-delay: 0.33s;
}

.dot-3 {
    animation-delay: 0.66s;
}

@keyframes blink {

    0%,
    100% {
        opacity: 0;
    }

    50% {
        opacity: 1;
    }
}

// 修改滚动条样式
::-webkit-scrollbar {
	width: 8px; /* 垂直滚动条的宽度 */
}
::-webkit-scrollbar-track {
  background: #f1f1f1; /* 滚动条轨道的背景颜色 */
  border-radius: 10px; /* 滚动条轨道的圆角 */
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  background: #c1c1c1; /* 滚动条滑块的颜色 */
  border-radius: 10px; /* 滚动条滑块的圆角 */
}

/* 鼠标悬停在滑块上时的样式 */
::-webkit-scrollbar-thumb:hover {
  background: #c1c1c1; /* 鼠标悬停时的颜色 */
}


// 动画效果
.active {
  animation: scaleUp .2s;
}

.active2 {
  animation: scaleUp2 .2s;
}
@keyframes scaleUp {
  from { margin-left:0; }
  to { margin-left:10vw; }
  
}
@keyframes scaleUp2 {
  from { margin-left:10vw; }
  to { margin-left:0; }
}

.active3 {
  animation: scaleUp3 .2s;
}

.active4 {
  animation: scaleUp4 .2s;
}


@keyframes scaleUp3 {
  from { margin-left:0; }
  to { margin-left: 5.5VW; }
  
}
@keyframes scaleUp4 {
  from { margin-left:5.5VW; }
  to { margin-left:0; }
}

</style>